import React, {Component, ReactElement} from "react";

export default class ErrorSummary extends Component {
  render(): ReactElement {
    return (
      <div className="error-message summary">Formularz zawiera błędy</div>
    );
  }
}
